// Numbers and dates in the creator's language (`studio.locale`: pt_BR → pt-BR).
const tag = locale => (locale || 'pt_BR').replace('_', '-');

export const formatNumber = (value, locale) => new Intl.NumberFormat(tag(locale)).format(value ?? 0);
export const formatPercent = (value, locale) => (value === null || value === undefined ? '—' : new Intl.NumberFormat(tag(locale), { style: 'percent', maximumFractionDigits: 1 }).format(value));
export const formatTime = (iso, locale) => new Intl.DateTimeFormat(tag(locale), { hour: '2-digit', minute: '2-digit' }).format(new Date(iso));

const UNITS = [['year', 31536e6], ['month', 2592e6], ['week', 6048e5], ['day', 864e5], ['hour', 36e5], ['minute', 6e4]];
export function formatRelative(iso, locale) {
  if (!iso) return '—';
  const elapsed = new Date(iso).getTime() - Date.now();
  const [unit, size] = UNITS.find(([, ms]) => Math.abs(elapsed) >= ms) || ['minute', 6e4];
  return new Intl.RelativeTimeFormat(tag(locale), { numeric: 'auto' }).format(Math.round(elapsed / size), unit);
}

// "60 min", "2 h": how long a reminder waits.
export const formatDelay = (minutes, locale) => {
  const unit = minutes < 60 ? 'minute' : 'hour';
  const value = minutes < 60 ? minutes : minutes / 60;
  return new Intl.NumberFormat(tag(locale), { style: 'unit', unit, unitDisplay: 'short', maximumFractionDigits: 1 }).format(value);
};

// `{{username}}` as the contact will read it.
export const withUsername = (text, handle) => (text || '').replace(/\{\{\s*username\s*\}\}/g, `@${handle}`);
